export default class InteractionDisabler {
	/**
	 * @param {import('ol/interaction').Interaction[]} interactions interactions
	 * @param {import('ol/interaction').Interaction[]} keepStateInteractions keepStateInteractions
	 */
	constructor(interactions, keepStateInteractions = []) {
		if (!interactions) {
			throw new Error('No interactions given');
		}

		this.interactions = interactions;
		this.keepStateInteractions = keepStateInteractions;
		this.interactionStateSave = [];
		this.isDisabled = false;
	}

	/**
	 * @returns {boolean} is disabled
	 */
	getIsDisabled() {
		return this.isDisabled;
	}

	disable() {
		if (this.isDisabled) {
			return;
		}
		this.isDisabled = true;

		this.interactionStateSave = [];
		this.interactions.forEach((interaction, index) => {
			if (this.keepStateInteractions.indexOf(interaction) > -1) {
				this.interactionStateSave[index] = null;
				return;
			}

			this.interactionStateSave[index] = interaction.getActive();
			interaction.setActive(false);
		});
	}

	enable() {
		if (!this.isDisabled) {
			return;
		}
		this.isDisabled = false;

		this.interactionStateSave.forEach((state, index) => {
			if (state !== null) {
				this.interactions.item(index).setActive(state);
			}
		});
	}
}
